import { useAppStore } from '@/stores/app'
import { loadSeigyoConfig } from '@npm/seigyo-maintenance-mode'
import { ECountry } from '../enum/country.enum'
import getMceUrlByCountry from './get-mce-url-by-country'

export default async () => {
  const { country } = useAppStore()
  const mceUrl = getMceUrlByCountry(country)
  const seigyoUrl = `${mceUrl}/saldo/FrontEndConfiguration.json`

  const seigyoConfig = await loadSeigyoConfig({
    URL: seigyoUrl,
    ActiveCountry: country,
    Countries: Object.keys(ECountry)
  })
  return seigyoConfig
}
